import { BotId } from '@feedyou/schema'
import { endpointHelpers } from '@features/serverBots/endpointHelpers'
import { useMemo } from 'react'

export function useBotMetadata(id?: BotId) {
  const data = endpointHelpers.getBotsMetadata.useQueryData()?.metadata

  return useMemo(() => data?.find(metadata => metadata.id === id), [data, id])
}
